"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcologyExperts = void 0;
var Tags_1 = require("../Tags");
var CardName_1 = require("../../CardName");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var PlayProjectCard_1 = require("../../deferredActions/PlayProjectCard");
var CardRenderer_1 = require("../render/CardRenderer");
var EcologyExperts = (function (_super) {
    __extends(EcologyExperts, _super);
    function EcologyExperts() {
        return _super.call(this, {
            name: CardName_1.CardName.ECOLOGY_EXPERTS,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.MICROBE],
            metadata: {
                cardNumber: 'P10',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1); }).br.br;
                    b.projectRequirements();
                }),
                description: 'Increase your plant production 1 step. Play a card from hand, ignoring global requirements.',
            },
        }) || this;
    }
    EcologyExperts.prototype.getRequirementBonus = function (player) {
        if (player.lastCardPlayed === this.name) {
            return 50;
        }
        return 0;
    };
    EcologyExperts.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.game.defer(new PlayProjectCard_1.PlayProjectCard(player));
        return undefined;
    };
    return EcologyExperts;
}(PreludeCard_1.PreludeCard));
exports.EcologyExperts = EcologyExperts;
